'use client';
import styled from 'styled-components';

export const Paragraph = styled.p`
  ${({ theme }) => theme.typography.body}
`;
